<!-- 
Dialog for editing the levy collection's invoice payment details.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md">
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Configure invoice payment details</v-toolbar-title>
          <v-spacer/>
          <our-user-guide-button topic="levy-collection-setup" section="configure-invoice"/>
        </v-toolbar>
        <our-busy-indicator :show="busy"/>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field 
                  :value="configuration.bpayBillerCode"
                  :rules="[rules.required]"
                  label="BPAY biller code*"
                  @input="update('bpayBillerCode', $event)"
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field 
                  :value="configuration.accountBsb"
                  :rules="[rules.required]"
                  label="Account BSB*"
                  @input="update('accountBsb', $event)"
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field 
                  :value="configuration.accountNumber"
                  :rules="[rules.required]"
                  label="Account number*"
                  @input="update('accountNumber', $event)"
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field 
                  :value="configuration.accountName"
                  :rules="[rules.required]"
                  label="Account name*"
                  @input="update('accountName', $event)"
                />
              </v-flex>
            </v-layout>
          </v-container>
          <our-required-field-indicator/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="busy" flat @click.native="hide">Cancel</v-btn>
          <v-btn 
            ref="save-button" :disabled="busy" flat color="primary" 
            type="submit" @click.prevent="save"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" :state-error="state.error"/>
  </v-dialog>
</template>

<script>
import * as action from "@/store/levy-collections/action-types";
import * as mutation from "@/store/levy-collections/mutation-types";
import filterMixins from "@/mixins/filter.mixins";
import ruleMixins from "@/mixins/rule.mixins";
import lookupMixins from "@/mixins/lookup.mixins";

export default {
  mixins: [ruleMixins, lookupMixins, filterMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      showValidationDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.editInvoiceConfiguration;
    },
    configuration() {
      return this.state.data;
    },
    busy() {
      return this.state.loading || this.state.saving;
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        this.$refs.form.reset();
        this.$store.dispatch(action.EDIT_INVOICE_CONFIGURATION_GET, this.levyCollectionId);
      }
    }
  },
  methods: {
    update(field, newValue) {
      this.$store.commit(mutation.EDIT_INVOICE_CONFIGURATION_SET_DATA, { [field]: newValue });
    },
    async save() {
      if (this.$refs.form.validate() && (await this.$store.dispatch(action.EDIT_INVOICE_CONFIGURATION_SAVE))) {
        this.hide();
      } else {
        this.showValidationDialog = true;
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
